import "./Blogs.css";
import BlogSection from "../BlogSection/BlogSection";
import { useEffect } from "react";
import { allBlogs, getMetaData } from "../../utils/Constant";

const Blogs = () => {
  useEffect(() => {
    const metaData = getMetaData("blogs");

    document.title = metaData.title;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = metaData.description; // Use .content instead of setAttribute
  }, []);

  return (
    <div className="bg-white min-vh-100 py-5">
      <BlogSection
        title={"Blogs"}
        subTitle={
          "Explore engaging articles covering tech, development tips, and digital insights. Stay updated with the latest trends, tutorials, and guides to boost your knowledge and creativity."
        }
        blogData={allBlogs}
      />
    </div>
  );
};

export default Blogs;
